// get_contest_category_criterias
export const GET_CONTEST_CATEGORY_CRITERIA = 'get_contest_category_criterias';
export const GET_CONTEST_CATEGORY_CRITERIA_SUCCESSFUL =
  'get_contest_category_criterias_successfull';
export const GET_CONTEST_CATEGORY_CRITERIA_FAILED =
  'get_contest_category_criterias_failed';

// create_contest_category_criteria
export const CREATE_CONTEST_CATEGORY_CRITERIA =
  'create_contest_category_criteria';
export const CREATE_CONTEST_CATEGORY_CRITERIA_SUCCESSFUL =
  'create_contest_category_criteria_successfull';
export const CREATE_CONTEST_CATEGORY_CRITERIA_FAILED =
  'create_contest_category_criteria_failed';

// update_contest_category_criteria
export const UPDATE_CONTEST_CATEGORY_CRITERIA =
  'update_contest_category_criteria';
export const UPDATE_CONTEST_CATEGORY_CRITERIA_SUCCESSFUL =
  'update_contest_category_criteria_successfull';
export const UPDATE_CONTEST_CATEGORY_CRITERIA_FAILED =
  'update_contest_category_criteria_failed';

// delete_contest_category_criteria
export const DELETE_CONTEST_CATEGORY_CRITERIA =
  'delete_contest_category_criteria';
export const DELETE_CONTEST_CATEGORY_CRITERIA_SUCCESSFUL =
  'delete_contest_category_criteria_successfull';
export const DELETE_CONTEST_CATEGORY_CRITERIA_FAILED =
  'delete_contest_category_criteria_failed';
